import { z } from "zod";

export const storageUploadResultSchema = z.object({
  objectKey: z.string(),
  publicUrl: z.string(),
  fileName: z.string(),
  contentType: z.string(),
  sizeBytes: z.number(),
  uploadedAt: z.string(),
});

export const storageObjectSummarySchema = z.object({
  objectKey: z.string(),
  fileName: z.string(),
  contentType: z.string().nullable().optional(),
  sizeBytes: z.number(),
  lastModified: z.string().nullable().optional(),
  publicUrl: z.string().nullable().optional(),
});

export const storagePrivateContentResponseSchema = z.object({
  content: z.string(),
});

export const storageNamespaceSchema = z.enum(["EMAILS", "LAYOUTS", "COMPONENTS"]);

export const storagePrivateSaveRequestSchema = z.object({
  namespace: storageNamespaceSchema,
  objectKey: z.string().optional(),
  fileName: z.string().optional(),
  content: z.string().min(1),
  contentType: z.string().optional(),
});

const layoutNodeSchema = z.object({
  type: z.literal("layout"),
  id: z.string(),
  grids: z.array(z.record(z.string(), z.unknown())),
});

export const newsletterDocumentSchema = z
  .object({
    name: z.string(),
    subject: z.string().optional(),
    updatedAt: z.string(),
    layout: layoutNodeSchema.optional(),
    root: z.record(z.string(), z.unknown()).optional(),
    /** @deprecated legacy field — ignored on save */
    schemaVersion: z.number().optional(),
    /** @deprecated legacy field — ignored on save */
    id: z.string().optional(),
  })
  .refine((data) => Boolean(data.layout || data.root), {
    message: "Document must contain layout or root",
  });

export const savedLayoutBlockSchema = z.object({
  name: z.string(),
  grid: z.record(z.string(), z.unknown()),
  /** @deprecated legacy field — ignored on save */
  schemaVersion: z.number().optional(),
});

// Schema del formato layout completo obsoleto: usato solo in lettura per retrocompatibilità
export const legacyLayoutSchema = z.object({
  name: z.string().optional(),
  layout: layoutNodeSchema,
  schemaVersion: z.number().optional(),
});

export const savedComponentSchema = z.object({
  name: z.string(),
  componentKey: z.string(),
  props: z.record(z.string(), z.unknown()),
  /** @deprecated legacy fields — ignored on save */
  schemaVersion: z.number().optional(),
  id: z.string().optional(),
  label: z.string().optional(),
});

export const parseStorageUploadResult = (data) => storageUploadResultSchema.parse(data);
export const parseStorageObjectSummaries = (data) =>
  z.array(storageObjectSummarySchema).parse(Array.isArray(data) ? data : []);
export const parseStoragePrivateContent = (data) => storagePrivateContentResponseSchema.parse(data);
export const parseNewsletterDocument = (data) => newsletterDocumentSchema.parse(data);
 